const CtaScrollSection = (gsap, ScrollTrigger, $) => {
	//the DOM element we would like to pin to the screen, in this case is the container with the image stack
	// trigger is the DOM element we use to start the pinning
	// let trigger = document.querySelector(".cta-flex-block ");
	let triggers = gsap.utils.toArray(".cta-flex-block");

	if(triggers.length === 0) return;

	triggers.forEach((trigger, index) => {
		let container = trigger.querySelector(".cta-flex-block__images");

		// using scroll trigger we initiate the scroll watch
		const timeline = new gsap.timeline({
			// eslint-disable-line
			scrollTrigger: {
				id: "contact",
				trigger: trigger,
				scrub: true, //  scrub allows the pinning to react to the scroll direction
				pin: container,
				start: "top top", // this is where we define when the pinning starts
				end: "bottom bottom", // and when it ends
			},
		});

		// add indexes to each of the images
		$(".cta-flex-block__images__images-wrapper a").each(function (i) {
			$(this).addClass("img-" + i);
		});

		// this function is responsible for pulling the correct image forward
		(function () {
			let contain = gsap.utils.toArray(".cta-flex-block__ctas__content");

			contain.forEach((item, index) => {
				// we get the class names that correspond with the correct images based on index
				let className = $(
					".cta-flex-block__images__images-wrapper a:eq(" + index + ")"
				).attr("class");
				let content = document.querySelector("." + className);

				const timeline = new gsap.timeline({
					scrollTrigger: {
						trigger: item,
						scrub: true,
						start: "center bottom",
						end: "bottom bottom",
					},
				});

				timeline.fromTo(
					content,
					{
						autoAlpha: 0,
						zIndex: 1 + index,
						ease: "none",
					},
					{
						autoAlpha: 1,
						zIndex: 1 + index,
						ease: "none",
					},
					0
				);
			});
		})();

		// this function is responsible for the animating the scaling of the images as they come in and out
		// and it targets the thumbnail itself
		(function () {
			let contain = gsap.utils.toArray(".cta-flex-block__ctas__content");

			contain.forEach((item, index) => {
				let className = $(
					".cta-flex-block__images__images-wrapper a:eq(" + index + ")"
				).attr("class");
				let thumb = $("." + className + " img");

				const timeline = new gsap.timeline({
					scrollTrigger: {
						trigger: item,
						scrub: true,
						start: "top bottom",
						end: "bottom top",
					},
				});

				timeline.fromTo(
					thumb,
					{
						scale: 1,
						ease: "none",
					},
					{
						scale: 1.15,
						ease: "none",
					},
					0
				);
			});
		})();
	});

	$(window).resize(function () {
		ScrollTrigger.refresh();
		ScrollTrigger.update();
	});
};

export default CtaScrollSection;
